import {PwaInstallService} from '@frontend/services/PwaInstallService'
import {useSyncExternalStore} from 'react'

// Состояние и действие установки PWA приложения.
// canInstall: true только если браузер поддерживает установку и приложение еще не установлено.
export function usePwaInstall(): {canInstall: boolean; install: () => Promise<boolean>;} {

    const canInstall = useSyncExternalStore(
        PwaInstallService.subscribe,
        PwaInstallService.getSnapshot,
        () => false
    )

    return {
        canInstall,
        install: () => PwaInstallService.install(),
    }
}
